(function () {
    "use strict";

    angular
        .module('Services')
        .factory('SiteMap', siteMap);

    function siteMap() {
        var map = {
            dashboard: {
              title: 'Dashboard',
              label: 'Home',
              link: '/',
              parent: false
            },
            settings: {
                title: 'Accounting',
                label: 'Accounting',
                link: '/accounting',
                parent: 'dashboard'
            },
            reporting: {
              title: 'Reporting',
              label: 'Reporting',
              link: '/reporting',
              parent: 'dashboard'
            },
            serviceTickets: {
              title: 'Service Tickets',
              label: 'Service Tickets',
              link: '/service-tickets',
              parent: 'dashboard'
            },
            shipment: {
              title: 'Shipment',
              label: 'Shipment',
              link: '/dashboard',
              parent: false
            },
            clients: {
              title: 'Clients',
              label: 'Clients',
              link: '/',
              parent: 'dashboard'
            },
            manifests: {
              title: 'Manifests',
              label: 'Manifests',
              link: '/manifests',
              parent: 'dashboard'
            },
            carriers: {
              title: 'Carriers',
              label: 'Carriers',
              link: '/carriers',
              parent: 'dashboard'
            },
            routingMatrix: {
              title: 'Routing Matrix',
              label: 'Routing Matrix',
              link: '/routing-matrix',
              parent: 'dashboard'
            },
            services: {
              title: 'Margins',
              label: 'Margins',
              link: '/margins',
              parent: 'dashboard'
            },
            marketplaces: {
              title: 'Marketplaces',
              label: 'Marketplaces',
              link: '/marketplaces',
              parent: 'dashboard'
            },
            APIAccess: {
              title: 'API Access',
              label: 'API Access',
              link: '/api-access',
              parent: 'dashboard'
            },
            accounting: {
              title: 'Accounting',
              label: 'Accounting',
              link: '/accounting',
              parent: 'dashboard'
            },
            accountsPayable: {
                title: 'Accounts Payable',
                label: 'Accounts Payable',
                link: '/accounts-payable',
                parent: 'dashboard'
            },
            affiliatesSales: {
              title: 'Affiliates Sales',
              label: 'Affiliates Sales',
              link: '/affiliates-sales',
              parent: 'dashboard'
            },
            administration: {
              title: 'Administration',
              label: 'Administration',
              link: '/administration',
              parent: 'dashboard'
            },
            onboarding: {
              title: 'Onboarding',
              label: 'Onboarding',
              link: '/onboarding',
              parent: 'dashboard'
            },
            BBABilling: {
              title: 'BBA Mastro Billing',
              label: 'BBA Mastro Billing',
              link: '/bba-Billing',
              parent: 'dashboard'
            },
            crossDock: {
              title: 'Cross Dock',
              label: 'Cross Dock',
              link: '/cross-dock',
              parent: 'dashboard'
            },
            transitWarranty: {
                title: 'Transit Warranty',
                label: 'Transit Warranty',
                link: '/transit-warranty',
                parent: 'dashboard'
            }
        };

        function getMapping(pageName, arrMap){
            if(!pageName)
                return false;
            var tempMap = arrMap || [];
            var page = map[pageName];
            tempMap.push(page);

            if(page.parent){
                getMapping(page.parent, tempMap);
            }

            return tempMap;
        };
        return {
          page: map,
          getMapping: getMapping
        };
    }

})();



// WEBPACK FOOTER //
// ./js/services/siteMap.js